// Task types matching the intranet
export const TASK_TYPES = [
  { value: 'PROJECT', label: 'PROJECT', group: 'Project' },
  { value: 'FALLOUT', label: 'FALLOUT', group: 'Project' },
  { value: 'UPDATE', label: 'UPDATE', group: 'Project' },
  { value: 'SUPPORT', label: 'SUPPORT', group: 'Project' },
  { value: 'FIX', label: 'FIX', group: 'Project' },
  { value: 'INTERNAL', label: 'INTERNAL', group: 'Project' },
  { value: 'QA', label: 'QA', group: 'Project' },
  { value: 'CODE_REVIEW', label: 'CODE REVIEW', group: 'Project' },
] as const;

// Billing codes for UPDATE task type
export const BILLING_CODES = [
  { value: '1', label: '01-0001 - Web Development' },
  { value: '15', label: '03-0001 - Web Update' },
  { value: '23', label: '08-0001 - Copywriting' },
  { value: '26', label: '10-0001 - Graphic Design' },
  { value: '27', label: '11-0001 - Search Engine Optimization' },
  { value: '31', label: '14-0001 - PPC Management' },
  { value: '39', label: '19-0001 - Social Media Management' },
  { value: '45', label: '25-0001 - Video Production' },
  { value: '62', label: '28-0001 - Customer Support' },
  { value: '46', label: '30-0001 - Misc. Labor' },
] as const;

export type TaskType = typeof TASK_TYPES[number]['value'];
export type BillingCode = typeof BILLING_CODES[number]['value'];

